﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconHourglassHigh } from "@tabler/icons-react";


export const FrecuenciaTiempoIcon = IconHourglassHigh  ;
export const FrecuenciaTiempoHelpText = '* Aquí se pueden ver las frecuencias de tiempo aplicables.';

export class catFrecuenciaTiempo extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FrecuenciaTiempo";
        this.def.columns.c_category_id.defaultValue = "FrecuenciaTiempo";
        this.Title = "Frecuencias de tiempo";
        this.HelpText = FrecuenciaTiempoHelpText;
        this.Icon = FrecuenciaTiempoIcon;
    }
}

